import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { JoinBoardPage } from "~/pages/join/join-board.page";
import { setPendingBoardInviteId } from "~/stores/onboarding";

/**
 * Phase 6 board-invitation join page. Sister to `/join` (org invitation).
 *
 * Accepting one of these creates a `board_members` row only — the invitee
 * never becomes an org teammate. Users not signed in are bounced through
 * `/login` with a redirect back here so they can complete auth. Users who
 * are still mid-onboarding are funneled to `/onboard` first, where they can
 * pick invitation order in the unified chooser.
 */
export const Route = createFileRoute("/join/board")({
  validateSearch: z.object({ id: z.string() }),
  beforeLoad: ({ context, search }) => {
    const user = context.user;
    if (!user) return;

    if (user.onboarding !== "done") {
      setPendingBoardInviteId(search.id);
      throw redirect({ to: "/onboard", replace: true });
    }
  },
  component: JoinBoardPage,
});
